import { Fragment } from 'react';
import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

const Row = styled.div`
  display: table-row;
`;

const SkeletonCell = styled(Skeleton)`
  display: table-cell;
`;

const SpacerRow = styled.div`
  display: table-row;
  height: ${spacing.half};
`;

type Props = {
  numRows: number;
  numColumns: number;
};

export const TableSkeleton = ({ numRows, numColumns }: Props) => (
  <>
    {Array(numRows)
      .fill({})
      .map((_, idx) => (
        <Fragment key={idx}>
          <SpacerRow />
          <Row>
            {Array(numColumns)
              .fill({})
              .map((x, i: number) => (
                <SkeletonCell key={i} height={52} shimmerSpeed={4500} />
              ))}
          </Row>
          <SpacerRow />
        </Fragment>
      ))}
  </>
);
